import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ArcComponent } from './arc.component';
import { AdminToolComponent } from './components/admin-tool/admin-tool/admin-tool.component';
import { ArcJapanComponent } from './components/admin-tool/arc-japan/arc-japan.component';
import { CagbcAdminComponent } from './components/admin-tool/cagbc-admin/cagbc-admin.component';
import { ClaimSchoolComponent } from './components/claim-school/claim-school.component';
import { CreateModelComponent } from './components/insight/create-model/create-model.component';
import { EcostruxureDashboardComponent } from './components/ecostruxure/dashboard/dashboard.component';
import { EcostruxureRedirectComponent } from './components/ecostruxure/redirect/redirect.component';
import { EcostruxureSelectProjectComponent } from './components/ecostruxure/select-project/select-project.component';
import { GsaPanelComponent } from './components/gsa-panel/gsa-panel.component';
import { HomeComponent } from './components/home/home.component';
import { LearnMoreComponent } from './components/learn-more/learn-more.component';
import { LoginComponent } from './components/login/login.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { MiddlewareComponent } from './components/middleware/middleware.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { PaymentSuccessComponent } from './components/forms/payment-success/payment-success.component';
import { PaymetricComponent } from './components/components/paymetric/paymetric.component';
import { PlaqueComponent } from './components/plaque/plaque.component';
import { PortfolioCreationComponent } from './components/forms/portfolio-creation/portfolio-creation.component';
import { PortfoliosComponent } from './components/portfolios/portfolios.component';
import { ProjectCreationComponent } from './components/forms/project-creation/project-creation.component';
import { ProjectPaymentComponent } from './components/forms/project-payment/project-payment.component';
import { ProjectSetupComponent } from './components/forms/project-setup/project-setup.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { SelectedAdminAppComponent } from './components/admin-tool/selected-admin-app.component';
import { SelectedPortfolioComponent } from './components/selected_portfolio/selected-portfolio.component';
import { SelectedProjectComponent } from './components/selected_project/selected-project.component';
import { UpgradeArcComponent } from './components/forms/upgrade-arc/upgrade-arc.component';
import { UserBillingComponent } from './components/user-billing/user-billing.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserReportsComponent } from './components/user-reports/user-reports.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: ArcComponent,
    children: [
      {
      		path: "login",
      		component: LoginComponent,
      		data: {
      			app: "login"
      		}
      	},
      	{
      		path: "login_middleware",
      		component: MiddlewareComponent,
      		data: {
      			app: "login_middleware"
      		}
      	},
      	{
      		path: "app/home/overview",
      		component: HomeComponent,
      		data: {
      			app: "home"
      		}
      	},
      	{
      		path: "app/projects/my-projects",
      		component: ProjectsComponent,
      		data: {
      			app: "projects"
      		}
      	},
      	{
      		path: "app/schools/claim-school",
      		component: ClaimSchoolComponent,
      		data: {
      			app: "claim-school"
      		}
      	},
      	{
      		path: "app/project/:leed_id/:app_name",
      		component: SelectedProjectComponent,
      		data: {
      			app: "selected_project"
      		}
      	},
      	{
      		path: "app/ecostruxure",
      		component: EcostruxureDashboardComponent,
      		data: {
      			app: "ecostruxure"
      		}
      	},
      	{
      		path: "ecostruxure/redirect",
      		component: EcostruxureRedirectComponent,
      		data: {
      			app: "ecostruxure-redirect"
      		}
      	},
      	{
      		path: "app/ecostruxure/select-project",
      		component: EcostruxureSelectProjectComponent,
      		data: {
      			app: "ecostruxure-select-project"
      		}
      	},
      	{
      		path: "app/ecostruxure",
      		component: EcostruxureDashboardComponent,
      		data: {
      			app: "ecostruxure"
      		}
      	},
      	//ADMIN TOOL URLS START
      	{
      		path: "admin/:app_name",
      		component: SelectedAdminAppComponent,
      		data: {
      			app: "selected-admin-app"
      		}
      	},
      	{
      		path: "admin",
      		component: AdminToolComponent,
      		data: {app: "admin-tool"}
      	},
      	{
      		path: "arc-japan-admin",
      		component: ArcJapanComponent,
      		data: {app: "arc_japan"}
      	},
      	{
      		path: "cagbc-admin",
      		component: CagbcAdminComponent,
      		data: {app: "cagbc_admin"}
      	},
      	//ADMIN TOOL URLS END
      	{
      		path: "app/registration",
      		component: ProjectCreationComponent,
      		data: {
      			app: "forms"
      		}
      	},
      	{
      		path: "registration/:leed_id/payment",
      		component: ProjectPaymentComponent,
      		data: {
      			app: "project-payment"
      		}
      	},
      	{
      		path: "registration/:leed_id/setup",
      		component: ProjectSetupComponent,
      		data: {
      			app: "project-setup"
      		}
      	},
      	{
      		path: "app/upgrade-arc",
      		component: UpgradeArcComponent,
      		data: {
      			app: "upgrade_arc"
      		}
      	},
      	{
      		path: "app/payment-success",
      		component: PaymentSuccessComponent,
      		data: {
      			app: "payment-success"
      		}

      	},
      	{
      		path: "app/portfolio/my-portfolios",
      		component: PortfoliosComponent,
      		data: {
      			app: "portfolios"
      		}
      	},
      	{
      		path: "app/portfolio/:portfolio_id/:app_name",
      		component: SelectedPortfolioComponent,
      		data: {
      			app: "selected_portfolio"
      		}
      	},
      	{
      		path: "app/portfolio/create",
      		component: PortfolioCreationComponent,
      		data: {
      			app: "portfolio-creation"
      		}
      	},
      	{
      		path: "paymetric",
      		component: PaymetricComponent,
      		data: {
      			app: "paymetric"
      		}
      	},
      	{
      		path: "app/notifications",
      		component: NotificationsComponent,
      		data: {
      			app: "notifications"
      		}
      	},
      	{
      		path: "app/billing",
      		component: UserBillingComponent,
      		data: {
      			app: "user-billing"
      		}
      	},
      	{
      		path: "app/reports",
      		component: UserReportsComponent,
      		data: {
      			app: "user-reports"
      		}
      	},
      	{
      		path: "app/profile",
      		component: UserProfileComponent,
      		data: {
      			app: "user-profile"
      		}
      	},
      	{
      		path: "app/learn-more",
      		component: LearnMoreComponent,
      		data: {
      			app: "learn-more"
      		}
      	},
      	{
      		path: "plaque/:leed_id/:key",
      		component: PlaqueComponent,
      		data: {
      			app: "plaque"
      		}
      	},
      	{
      		path: "app/model/registration",
      		component: CreateModelComponent,
      		data: {
      			app: "create-model"
      		}
      	},
      	{
      		path: "maintenance",
      		component: MaintenanceComponent,
      		data: {
      			app: "maintenance"
      		}
      	},
      	{
      		path: "app/gsa-panel",
      		component: GsaPanelComponent,
      		data: {
      			app: "gsa-panel"
      		}
      	},
      	// ** path should alway be at the last !!INDEX!! of appRoutes
      	{
      		path: "app/project/:leed_id/:app_name/v2",
      		redirectTo: 'app/project/:leed_id/:app_name'
      	},
      	{
      		path: '**',
      		redirectTo: '/login_middleware',
      		pathMatch: 'full'
      	}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule]
})
export class ArcRoutingModule {}
